module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "index_oo"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box3 cpoint"
  }, [_c('div', {
    staticClass: "box3_right",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "box3_center",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "placeholder": "请输入您要搜索的关键词"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.searchEnterFun($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box3_sou",
    on: {
      "click": _vm.tosearch
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._v("搜索")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box55 cpoint"
  }, [_c('div', {
    staticClass: "box2"
  }, [_c('div', {
    staticClass: "box2_center",
    staticStyle: {
      "min-height": "545px"
    }
  }, [_c('table', {
    staticClass: "bo",
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "trcla"
    }, [_c('td', [_vm._v(_vm._s(item.shop.shop_name ? item.shop.shop_name : '--'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "260px"
      }
    }, [_vm._v(_vm._s(item.shop.people_name ? item.shop.people_name : '--'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "260px"
      }
    }, [_vm._v(_vm._s(item.shop.mobile ? item.shop.mobile : '--'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.room_number ? item.room_number : '--'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.lease_time ? item.lease_time : '--'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.shop.createtime ? item.shop.createtime : '--'))]), _vm._v(" "), _c('td', {
      staticClass: "box2_tt flex justify-around align-center pointer",
      staticStyle: {
        "color": "#6491ff"
      },
      on: {
        "click": function($event) {
          return _vm.showdetail(item)
        }
      }
    }, [_vm._v("\n                详情\n              ")])])
  })], 2), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.emptyedit
    }
  }, [(!_vm.list.length) ? _c('nomore') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "response text-center padding-tb"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagesize,
      "hide-on-single-page": true,
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "企业详情",
      "visible": _vm.addcompany
    },
    on: {
      "update:visible": function($event) {
        _vm.addcompany = $event
      }
    }
  }, [(_vm.cominfo) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "60%",
      "margin": "0 auto"
    }
  }, [_c('el-form', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "model": _vm.cominfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业名称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.shop.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.cominfo.shop, "shop_name", $$v)
      },
      expression: "cominfo.shop.shop_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业联系人",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.shop.people_name),
      callback: function($$v) {
        _vm.$set(_vm.cominfo.shop, "people_name", $$v)
      },
      expression: "cominfo.shop.people_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.shop.mobile),
      callback: function($$v) {
        _vm.$set(_vm.cominfo.shop, "mobile", $$v)
      },
      expression: "cominfo.shop.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.shop.add_detail),
      callback: function($$v) {
        _vm.$set(_vm.cominfo.shop, "add_detail", $$v)
      },
      expression: "cominfo.shop.add_detail"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属分类",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.shop.cat_name),
      callback: function($$v) {
        _vm.$set(_vm.cominfo.shop, "cat_name", $$v)
      },
      expression: "cominfo.shop.cat_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "入驻时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.shop.createtime),
      callback: function($$v) {
        _vm.$set(_vm.cominfo.shop, "createtime", $$v)
      },
      expression: "cominfo.shop.createtime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "租赁房间号",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.room_number),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "room_number", $$v)
      },
      expression: "cominfo.room_number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "租赁时长",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.lease_time),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "lease_time", $$v)
      },
      expression: "cominfo.lease_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.pay_way),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "pay_way", $$v)
      },
      expression: "cominfo.pay_way"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "房租价格",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.price),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "price", $$v)
      },
      expression: "cominfo.price"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "费用到期时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "type": "date",
      "disabled": "",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.cominfo.expire_time),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "expire_time", $$v)
      },
      expression: "cominfo.expire_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "到期应收",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px"
    },
    attrs: {
      "disabled": "",
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.cominfo.real_money),
      callback: function($$v) {
        _vm.$set(_vm.cominfo, "real_money", $$v)
      },
      expression: "cominfo.real_money"
    }
  })], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index1_until cpoint"
  }, [_c('div', {
    staticClass: "index1_until_shu"
  }), _vm._v(" "), _c('div', {
    staticClass: "index1_until_text"
  }, [_vm._v("企业列表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box3_tu"
  }, [_c('img', {
    staticStyle: {
      "width": "25px",
      "height": "25px"
    },
    attrs: {
      "src": "/static/assets/images/sou.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "bo_cc",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('td', [_vm._v("企业名称")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "260px"
    }
  }, [_vm._v("企业联系人")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "260px"
    }
  }, [_vm._v("联系人电话")]), _vm._v(" "), _c('td', [_vm._v("租赁房间号")]), _vm._v(" "), _c('td', [_vm._v("租赁时长")]), _vm._v(" "), _c('td', [_vm._v("入驻时间")]), _vm._v(" "), _c('td', [_vm._v("操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c09ad10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/systemitem/companylist.vue
// module id = 395
// module chunks = 1